module.exports = __webpack_public_path__ + "34bc775d/img/trash-icon.ff8201c7.svg";